import { render, staticRenderFns } from "./PlagueMonitoringDetails.vue?vue&type=template&id=e4c14ecc&scoped=true&lang=html&"
import script from "./PlagueMonitoringDetails.vue?vue&type=script&lang=js&"
export * from "./PlagueMonitoringDetails.vue?vue&type=script&lang=js&"
import style0 from "./PlagueMonitoringDetails.vue?vue&type=style&index=0&id=e4c14ecc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c14ecc",
  null
  
)

export default component.exports